import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { handelAdminLogin } from "../../store/features/auth/authSlice";
import { useNavigate } from "react-router";

const AdminLogin = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [random, setRandomNumber] = useState(0);
  const ShowRandomNumber = () => {
    setRandomNumber(
      (Math.floor(Math.random() * 10000) + 10000).toString().substring(1)
    );
  };
  useEffect(() => {
    ShowRandomNumber();
  }, []);

  return (
    <div>
      <div className="admin_login w-[100%] flex justify-center items-center h-[100vh] bg-cover bg-center bg-no-repeat  bg-[url('https://ag.bigwin.buzz/adminfiles/img/bg-login.jpg')]">
        <div className="bg-[#14805e] rounded w-[600px] h-[500px]">
          <div className=" h-[100%] flex  ">
            <img
              src="https://ag.bigwin.buzz/adminfiles/img/bg-login_wrap.webp?v=0.01"
              alt=""
              className=" admin_logo h-[100%]"
            />
            <div className="text ml-[30px] justify-center flex flex-col">
              <h2 className="font-bold text-white text-[18px]">Agent Login</h2>
              <input type="text" className="mt-3 w-[200px] py-2" />
              <input type="password" className=" mt-3  w-[200px] py-2" />
              <div className="relative">
                <input
                  type="text"
                  className=" mt-3 w-[200px] py-2"
                  placeholder="validation"
                />
                <span className=" absolute right-[30px] top-[20px] text-black">
                  {random}
                </span>
              </div>
              <button
                className="bg-red-600 text-white rounded-lg mt-4 py-1 capitalize
              "
                onClick={() => {
                  dispatch(handelAdminLogin({ adminLogin: true }));
                  navigation("/admin/home");
                }}
              >
                login with demo id
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;

{
  /* <div className="text flex flex-col">
              <h2 className="font-bold text-[18px]">Agent Login</h2>
              <input type="text" className="mt-3 w-[200px] py-2" />
              <input type="password" className=" mt-3  w-[200px] py-2" />
              <button
                className="bg-red-600 text-white rounded-lg mt-4 py-1 capitalize
              "
                onClick={() => {
                  dispatch(handelAdminLogin({ adminLogin: true }));
                  navigation("/admin/home");
                }}
              >
                login with demo id
              </button>
            </div> */
}
